import { render, staticRenderFns } from "./SoundButton.vue?vue&type=template&id=3253a216&scoped=true&"
import script from "./SoundButton.vue?vue&type=script&lang=js&"
export * from "./SoundButton.vue?vue&type=script&lang=js&"
import style0 from "./SoundButton.vue?vue&type=style&index=0&id=3253a216&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3253a216",
  null
  
)

export default component.exports